// extracted by mini-css-extract-plugin
export var blue = "_39-g";
export var brand = "_39-c";
export var darkGrey = "_39-f";
export var disabled = "_39-6";
export var disabledSubtle = "_39-7";
export var error = "_39-8";
export var green = "_39-h";
export var grey = "_39-e";
export var icon = "_39-0";
export var inherit = "_39-b";
export var lightGrey = "_39-d";
export var orange = "_39-j";
export var pink = "_39-l";
export var primary = "_39-1";
export var purple = "_39-m";
export var quaternary = "_39-4";
export var quinary = "_39-5";
export var red = "_39-k";
export var secondary = "_39-2";
export var success = "_39-a";
export var tertiary = "_39-3";
export var warning = "_39-9";
export var white = "_39-n";
export var yellow = "_39-i";